<script setup lang="ts">
const props = defineProps<{
  isTrend: boolean;
  percentageChange: number;
}>();

const trendIcon = props.isTrend ? '/assets/arrow-up.svg' : '/assets/arrow-down.svg'
</script>

<template>
  <div :class="isTrend?'percentage-change-green':'percentage-change-red'">
    <img
        loading="lazy"
        :src="trendIcon"
        class="trend-icon"
        alt=""
    />
    <span>{{ percentageChange }}%</span>
  </div>
</template>

<style scoped>

.percentage-change-green {
  display: flex;
  align-items: center;
  color: var(--green-4, #35aa09);
  gap: 2px;
}
.percentage-change-red {
  display: flex;
  align-items: center;
  color: var(--green-4, #E61A1A);
  gap: 2px;
}

.trend-icon {
  width: 16px;
  aspect-ratio: 1;
}
</style>